export default {
  tips: [],
  tip: undefined,
};
